import { render, staticRenderFns } from "./thai.vue?vue&type=template&id=7f0b0701&scoped=true&"
import script from "./thai.vue?vue&type=script&lang=js&"
export * from "./thai.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f0b0701",
  null
  
)

export default component.exports